export default __webpack_public_path__ + "pdf/Daniel_Haehn.84ed0d8.pdf";